export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email'
  ],
  'requiredFields': {
    'default': [
      'Company'
    ],
    'consulting': [
      'Company',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'ContractNumber'
    ],
    'career': [],
    'cooperation': [
      'Company',
      'RequestTopic',
    ]
  }
}
